import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ChatTab } from "@/domains/chat/constants/chat";
import { bModeSelector, currTabChatSelector, setChatCommand } from "@/domains/chat/slice";

export default () => {
  const dispatch = useAppDispatch();
  const currTab = useAppSelector(currTabChatSelector);
  const isBMode = useAppSelector(bModeSelector);

  useEffect(() => {
    switch (currTab) {
      case ChatTab.Faction: {
        dispatch(setChatCommand(isBMode ? "fb" : "f"));
        break;
      }
      case ChatTab.Family: {
        dispatch(setChatCommand(isBMode ? "fab" : "fa"));
        break;
      }
      case ChatTab.News: {
        dispatch(setChatCommand(isBMode ? "nb" : "n"));
        break;
      }
      case ChatTab.Radio: {
        dispatch(setChatCommand(isBMode ? "rb" : "r"));
        break;
      }
      default: {
        dispatch(setChatCommand(""));
      }
    }
  }, [currTab, isBMode, dispatch]);
};
